import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LeadformComponent } from './leadform/leadform.component'; 
import { FormsModule,ReactiveFormsModule } from '@angular/forms';

import { MatloaderComponent } from './matloader/matloader.component';
import { MatProgressBarModule } from '@angular/material/progress-bar'; 
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'; 

@NgModule({
  declarations: [
    MatloaderComponent,
    LeadformComponent
  ],
  imports: [
    CommonModule, 
    MatProgressBarModule,
    MatProgressSpinnerModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    MatloaderComponent,
    LeadformComponent
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})

export class SharedModule { }
